import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Table, Button, Space, Row } from 'antd';
import { getSortState, JhiItemCount, JhiPagination, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getClasses, getClassesProf } from './classe.reducer';
import { IClasse } from 'app/shared/model/classe.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT, AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { getSession } from 'app/shared/reducers/authentication';
export const Classe = (props: RouteComponentProps<{ ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const isProf = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.PROFESSEUR]));
  const account = useAppSelector(state => state.authentication.account);
  useEffect(() => {
    dispatch(getSession());
    dispatch(getEcole(props.match.params.ecoleid));
    if (isProf) {
      dispatch(getClassesProf({ ecoleId: props.match.params.ecoleid, profId: account.id }));
    } else {
      dispatch(getClasses(props.match.params.ecoleid));
    }
  }, []);

  const { match } = props;
  const classeList = useAppSelector(state => state.classe.entities);
  const totalItems = useAppSelector(state => state.classe.totalItems);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const isNotComptable = !useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.COMPTABLE]));
  const isNotSurveillantGeneral = !useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.SURVEILLANT_GENERAL])
  );
  const columns = [
    {
      title: 'CLASSES',
      dataIndex: 'classe',
      key: 'classe',
    },
    {
      title: 'CYCLE',
      dataIndex: 'cycle',
      key: 'cycle',
      render: value => value || '-',
    },
    {
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <div>
          <Row className="justify-content-end">
            <Button type="primary" style={{ height: 'auto', width: 'auto' }}>
              <Link to={`/classe/${currentEcole && currentEcole.id}/${id}/details`} id="jh-create-entity" data-cy="entityCreateButton">
                <FontAwesomeIcon icon="eye" />
                &nbsp;
              </Link>
            </Button>
            &nbsp;
          </Row>
        </div>
      ),
    },
  ];

  const data = classeList.map((classe, i) => ({
    classe: classe.nom,
    cycle: classe.cycleNom,
    id: classe.id,
  }));

  return (
    <div>
      <h2 id="classe-heading" data-cy="ClasseHeading">
        <Translate contentKey="korischoolApp.classe.home.title">Classes</Translate>
        {isNotComptable && isNotSurveillantGeneral && !isProf && (
          <div style={{ textAlign: 'right' }}>
            <Link
              to={`/classe/${currentEcole && currentEcole.id}/new`}
              className="btn jh-create-entity"
              id="jh-create-entity"
              style={{ backgroundColor: '#F28E19', color: 'white' }}
              data-cy="entityCreateButton"
            >
              <FontAwesomeIcon icon="plus" />
              &nbsp;
              <Translate contentKey="korischoolApp.classe.home.createLabel">Create new Classe</Translate>
            </Link>
          </div>
        )}
      </h2>
      <div className="table-responsive">
        <Table columns={columns} dataSource={data} />
      </div>
    </div>
  );
};

export default Classe;
